export class ConfigProfile {
  id: string;
  name: string;
  selected: boolean;

  constructor() {}
}
